import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのLicensesロゴアイコン
 */
export function ProductLogoSmallLicenses({
  size = 20,
  color = '#1874A1',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M360 216C406.392 216 444 253.608 444 300C444 328.545 429.761 353.763 408 368.942V436.687C408 443.814 399.382 447.382 394.343 442.343L360 408L325.657 442.343C320.618 447.382 312 443.814 312 436.687V368.942C290.239 353.763 276 328.545 276 300C276 253.608 313.608 216 360 216ZM360 264C340.118 264 324 280.118 324 300C324 319.882 340.118 336 360 336C379.882 336 396 319.882 396 300C396 280.118 379.882 264 360 264Z"
        fill={color}
      />
      <path
        d="M348.271 48.3467C368.153 48.3469 384.271 64.4646 384.271 84.3467V179.5C384.271 186.127 378.898 191.5 372.271 191.5H360.271C353.643 191.5 348.271 186.127 348.271 179.5V84.3467H120.271V408.347H267.5C274.127 408.347 279.5 413.719 279.5 420.347V432.347C279.5 438.974 274.127 444.347 267.5 444.347H120.271C100.388 444.347 84.2697 428.229 84.2695 408.347V84.3467C84.2695 64.4644 100.388 48.3467 120.271 48.3467H348.271Z"
        fill={color}
      />
      <path
        d="M235.271 324C241.898 324 247.271 329.373 247.271 336V348C247.271 354.627 241.898 360 235.271 360H168.271C161.643 360 156.271 354.627 156.271 348V336C156.271 329.373 161.643 324 168.271 324H235.271Z"
        fill={color}
      />
      <path
        d="M235.271 228C241.898 228 247.271 233.373 247.271 240V252C247.271 258.627 241.898 264 235.271 264H168.271C161.643 264 156.271 258.627 156.271 252V240C156.271 233.373 161.643 228 168.271 228H235.271Z"
        fill={color}
      />
      <path
        d="M276.271 132C282.898 132 288.271 137.373 288.271 144V156C288.271 162.627 282.898 168 276.271 168H168.271C161.643 168 156.271 162.627 156.271 156V144C156.271 137.373 161.643 132 168.271 132H276.271Z"
        fill={color}
      />
    </svg>
  );
}
